export const deprecated_light = '0px 4px 8px rgba(0, 0, 0, 0.08)'
export const deprecated_medium = '0px 8px 20px rgba(0, 0, 0, 0.16)'

export const button = {
    default: '0 -1px 0 rgba(0,0,0,.04), 0 1px 2px rgba(0,0,0,.12), 0 4px 10px rgba(0,0,0,.10)',
    hover: '0 -1px 0 rgba(0,0,0,.04), 0 2px 4px rgba(0,0,0,.12), 0 10px 20px rgba(0,0,0,.12)',
    secondary: '0 -1px 0 rgba(0,0,0,.03), 0 1px 2px rgba(0,0,0,.08), 0 4px 10px rgba(0,0,0,.06)',
}

export const card = '0 2px 4px rgba(0,0,0,.03), 0 12px 32px rgba(0,0,0,.06), 0 40px 80px rgba(0,0,0,.11)'

export const modal = '0 1px 2px rgba(0,0,0,.06), 0 10px 24px rgba(0,0,0,.10)'

// text area hover + button default
export const sm = '0px 1px 3px 0px rgba(0, 0, 0, 0.08)'
